import React, { memo, useCallback } from "react";
import OptionTag from "./OptionTag";

const QuestionOptions = memo(({ options, onSelect, selectedValue }) => {
  const handleTagsClick = useCallback(
    (e) => {
      const btn = e.target.closest("button[data-value]");
      if (!btn || !e.currentTarget.contains(btn)) return;
      const raw = btn.getAttribute("data-value");
      if (raw == null) return;
      onSelect?.(raw);
    },
    [onSelect]
  );

  if (!Array.isArray(options)) {
    return null;
  }

  return (
    <div className="services-picker__question-list">
      <div className="services-picker__question-info">
        <div
          className="services-picker__tags vh-assessment__tags"
          onClick={handleTagsClick}
          role="group"
        >
          {options.map((option, index) => (
            <OptionTag
              key={`${option.value}-${index}`}
              value={option.value}
              label={option.label}
              orderIds={option.orderIds}
              staggerMs={index * 42}
              isSelected={selectedValue === option.value}
            />
          ))}
        </div>
      </div>
    </div>
  );
});

QuestionOptions.displayName = 'QuestionOptions';

export default QuestionOptions; 